// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"f4399ba1","767":"30e6be40"}[chunkId] + ".chunk.js";
};